var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSurpriseMe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 100,
    viewBox: "0 0 134 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8375 89.2762C26.4502 89.2766 26.0697 89.175 25.7342 88.9816L10.4576 80.1618C10.303 80.0725 10.1747 79.9442 10.0854 79.7896C9.99619 79.635 9.94922 79.4596 9.94922 79.2811C9.94922 79.1026 9.99619 78.9272 10.0854 78.7726C10.1747 78.618 10.303 78.4896 10.4576 78.4003L42.7406 59.762L42.9793 60.1755L10.6963 78.8138C10.6143 78.8612 10.5462 78.9293 10.4989 79.0113C10.4515 79.0934 10.4266 79.1864 10.4266 79.2811C10.4266 79.3758 10.4515 79.4688 10.4989 79.5508C10.5462 79.6328 10.6143 79.701 10.6963 79.7483L25.9729 88.5681C26.2358 88.7195 26.5339 88.7992 26.8373 88.7992C27.1408 88.7992 27.4389 88.7195 27.7018 88.5681L56.2287 72.0985L56.4674 72.512L27.9405 88.9816C27.6051 89.175 27.2246 89.2766 26.8375 89.2762Z",
    fill: "#E1E5F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7293 23.254V25.8682C11.7109 27.6109 9.26386 31.8493 9.26386 35.3348L7 36.6418C7 31.7127 10.4606 25.7188 14.7293 23.254Z",
    fill: "url(#paint0_linear_835_138800)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.729 25.8682V23.254C16.2682 22.3654 17.6985 22.0652 18.9031 22.265L17.6805 25.1687C16.8288 25.0274 15.8173 25.2398 14.729 25.8682Z",
    fill: "#5555C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2111 33.1985C18.2232 35.4022 16.5857 37.4188 14.7293 38.4903C11.7109 40.2332 9.26386 38.8204 9.26386 35.3348C9.26386 31.8493 11.7109 27.6109 14.7293 25.8682V23.254C10.4606 25.7188 7 31.7127 7 36.6418C7 41.5712 10.4606 43.5691 14.7293 41.1045C17.3545 39.5889 19.6703 36.7372 21.0673 33.6206L19.2111 33.1985Z",
    fill: "url(#paint1_linear_835_138800)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1958 29.0238C20.1958 26.7949 19.1926 25.4194 17.6816 25.1688L18.9042 22.2651C21.0411 22.6193 22.4597 24.5647 22.4597 27.7168C22.4597 29.6147 21.9429 31.6693 21.0681 33.6208L19.2119 33.1986C19.8254 31.8902 20.1604 30.4685 20.1958 29.0238Z",
    fill: "#DADFF2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0082 35.0369L12.4576 35.3549L12.4571 32.8988L11.7998 33.5129V32.9994L12.949 31.8603L13.0082 31.8263V35.0369ZM15.7772 32.1129C15.7871 32.5108 15.7057 32.9057 15.5392 33.2673C15.3892 33.5843 15.1457 33.8477 14.8415 34.0222C14.5392 34.1968 14.308 34.2151 14.1478 34.0772C13.9874 33.9393 13.9054 33.6565 13.9017 33.2287V32.6389C13.8915 32.2394 13.9741 31.843 14.1432 31.4808C14.2938 31.1668 14.5359 30.9057 14.8378 30.732C15.1401 30.5574 15.3713 30.5387 15.5315 30.6758C15.6914 30.8129 15.7733 31.0953 15.7772 31.523V32.1129ZM15.2266 31.7826C15.2447 31.6021 15.2119 31.4201 15.132 31.2573C15.0693 31.1722 14.9712 31.1683 14.8378 31.2454C14.7063 31.3221 14.6049 31.4415 14.5506 31.5837C14.4822 31.7753 14.4491 31.9776 14.4527 32.181V32.9604C14.4366 33.1419 14.4684 33.3243 14.545 33.4896C14.6068 33.5809 14.7056 33.5873 14.8415 33.5088C14.9772 33.4299 15.0805 33.3055 15.1331 33.1576C15.1996 32.9603 15.2312 32.7529 15.2266 32.5447V31.7826ZM16.1415 30.639C16.1436 30.4358 16.201 30.2371 16.3077 30.0642C16.4121 29.8837 16.562 29.7338 16.7424 29.6293C16.8035 29.5814 16.8757 29.5497 16.9522 29.5373C17.0288 29.5248 17.1073 29.5319 17.1804 29.558C17.2912 29.6153 17.3464 29.7475 17.3462 29.9545V30.113C17.3452 30.3158 17.2879 30.5144 17.1807 30.6865C17.0753 30.8653 16.9257 31.0139 16.7462 31.1179C16.6851 31.1656 16.6129 31.1971 16.5364 31.2095C16.4599 31.2219 16.3815 31.2148 16.3084 31.1889C16.1977 31.1319 16.1421 31.0006 16.1415 30.7951V30.639ZM16.5077 30.5996C16.5031 30.6322 16.5067 30.6653 16.5182 30.6961C16.5298 30.7269 16.5488 30.7543 16.5737 30.7758C16.6012 30.7894 16.6321 30.7949 16.6627 30.7915C16.6932 30.7882 16.7222 30.7762 16.7462 30.7569C16.8187 30.7143 16.8775 30.6519 16.9159 30.577C16.9575 30.4982 16.979 30.4103 16.9786 30.3212L16.9783 30.1572C16.9827 30.1245 16.9792 30.0913 16.9683 30.0602C16.9574 30.0291 16.9394 30.001 16.9156 29.9782C16.8737 29.9477 16.8161 29.9536 16.7424 29.9961C16.6702 30.0387 16.6113 30.1008 16.5725 30.1751C16.529 30.2557 16.5068 30.346 16.5079 30.4376L16.5077 30.5996ZM16.8546 32.5752L16.586 32.5633L17.9413 29.2776L18.2098 29.2895L16.8546 32.5752ZM17.4683 31.6757C17.4697 31.472 17.5278 31.2726 17.6359 31.1C17.7412 30.9207 17.8909 30.7716 18.0706 30.6671C18.1318 30.6196 18.2039 30.588 18.2803 30.5752C18.3567 30.5625 18.4351 30.5689 18.5084 30.594C18.6193 30.6496 18.6748 30.7823 18.6748 30.9923V31.1505C18.6735 31.3523 18.6169 31.5499 18.5112 31.7218C18.4059 31.902 18.2554 32.0516 18.0746 32.1557C18.0133 32.204 17.9406 32.2359 17.8636 32.2483C17.7865 32.2608 17.7075 32.2535 17.634 32.227C17.5238 32.1691 17.4685 32.0396 17.4683 31.8385V31.6757ZM17.8345 31.6386C17.8309 31.6702 17.8352 31.7023 17.8472 31.7317C17.8592 31.7612 17.8784 31.7872 17.903 31.8073C17.9296 31.8225 17.9602 31.8294 17.9907 31.8272C18.0213 31.8249 18.0505 31.8136 18.0746 31.7947C18.1502 31.7516 18.2122 31.6881 18.2533 31.6114C18.2944 31.5347 18.313 31.448 18.307 31.3611L18.3072 31.1924C18.3116 31.1599 18.308 31.1268 18.2967 31.096C18.2854 31.0652 18.2668 31.0376 18.2424 31.0157C18.2151 31.0019 18.1843 30.9962 18.1538 30.9994C18.1234 31.0027 18.0945 31.0146 18.0706 31.0339C17.9979 31.0767 17.9385 31.139 17.8993 31.2138C17.8561 31.293 17.8338 31.3819 17.8345 31.4721V31.6386Z",
    fill: "#6A6AE2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8281 52.4973C16.8281 52.9242 17.1302 53.0984 17.4997 52.8851L36.0245 42.19C36.2198 42.0621 36.3823 41.8902 36.499 41.6881C36.6156 41.486 36.6832 41.2593 36.6963 41.0263V25.5138C36.6963 25.0871 36.394 24.9127 36.0245 25.1259L17.4997 35.8213C17.3044 35.9491 17.142 36.121 17.0253 36.3231C16.9087 36.5252 16.8411 36.7519 16.8281 36.9848V52.4973Z",
    fill: "#F2F2F7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0515 52.9428L17.0509 52.9434L17.043 52.9387L17.0515 52.9428Z",
    fill: "#D0D4F6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.941 35.4981L35.4658 24.8028C35.5332 24.7542 35.6122 24.7242 35.6949 24.7158C35.7775 24.7074 35.8609 24.7209 35.9367 24.7551L35.9369 24.7549L35.9381 24.7557L35.9423 24.758L36.4966 25.0781L36.4964 25.0782C36.4206 25.0441 36.3372 25.0306 36.2546 25.039C36.1719 25.0473 36.0929 25.0773 36.0255 25.1259L17.5007 35.8213C17.3054 35.9491 17.143 36.121 17.0263 36.3231C16.9097 36.5252 16.8421 36.7518 16.8291 36.9848V52.4974C16.8215 52.5776 16.8342 52.6584 16.8661 52.7325C16.8979 52.8065 16.9478 52.8713 17.0112 52.921L16.4923 52.6211L16.4928 52.6204C16.416 52.576 16.354 52.51 16.3142 52.4308C16.2745 52.3515 16.2589 52.2623 16.2692 52.1742V36.6616C16.2823 36.4286 16.3499 36.202 16.4666 35.9999C16.5832 35.7978 16.7457 35.6259 16.941 35.4981Z",
    fill: "url(#paint2_linear_835_138800)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2397 30.9479L35.2698 28.6212V27.8802L31.2397 30.2073V30.9479Z",
    fill: "#F2BD42"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5542 42.5527L35.3809 39.1886V38.8184L29.5542 42.1825V42.5527Z",
    fill: "#4141AA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2202 42.5461L34.2122 40.8187V40.4485L31.2202 42.1757V42.5461Z",
    fill: "#4141AA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6064 40.5911L35.3822 40.1433V39.7731L34.6064 40.2209V40.5911Z",
    fill: "#4141AA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5938 40.9299L31.2767 33.0302V32.6599L17.5938 40.5596V40.9299ZM32.2016 32.1259V32.4962L33.9333 31.4964V31.1261L32.2016 32.1259Z",
    fill: "#4141AA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.763 42.9986L24.5977 41.3404L25.763 38.3365L28.0938 36.9907L29.2593 38.6489L28.0938 41.6529L25.763 42.9986Z",
    fill: "#D0D4F6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0327 63.5535L97.631 60.5822L98.4249 61.0401L104.565 57.4948L106.282 58.4863L100.141 62.0316L101.181 62.6312L96.0327 63.5535Z",
    fill: "#E1E5F4"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M55.1434 55.8241H37.3877L49.7305 62.9505L37.3877 70.0767H55.1434L67.4869 62.9505L55.1434 55.8241Z",
    fill: "url(#paint3_linear_835_138800)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M29.8953 64.0768L23.0938 64.077L35.4363 71.2037L23.0938 78.3299L29.8953 78.3296L42.2386 71.2032L29.8953 64.0768Z",
    fill: "url(#paint4_linear_835_138800)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M87.0721 47.5715L80.2705 47.572L92.6133 54.6982L80.2705 61.8249L87.0721 61.8244L99.4156 54.698L87.0721 47.5715Z",
    fill: "url(#paint5_linear_835_138800)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M118.49 39.3188H65.9771L78.3199 46.445L65.9771 53.5717H118.49V46.445V39.3188Z",
    fill: "url(#paint6_linear_835_138800)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M75.5799 47.5714H51.6831L64.0259 54.6978L51.6831 61.8243H75.5799L87.9232 54.6978L75.5799 47.5714Z",
    fill: "url(#paint7_linear_835_138800)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M87.3353 67.6311L86.495 67.1458C86.6174 67.2105 86.7215 67.3051 86.7975 67.4209C86.8736 67.5366 86.9191 67.6697 86.93 67.8078V68.3378C86.9162 68.4899 86.8622 68.6355 86.7735 68.7597C86.6847 68.884 86.5645 68.9823 86.4251 69.0446L47.9426 91.2645C47.5882 91.4525 47.1932 91.5513 46.792 91.5521V91.5559H47.6458V91.5552C48.0663 91.5614 48.4815 91.4614 48.853 91.2645L87.3353 69.0446C88.0085 68.6558 88.0085 68.0199 87.3353 67.6311Z",
    fill: "url(#paint8_linear_835_138800)"
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9415 90.7347C47.562 90.9263 47.1428 91.0261 46.7176 91.0261C46.2925 91.0261 45.8733 90.9263 45.4937 90.7347L26.271 79.6352C25.5978 79.2466 25.5978 78.6105 26.271 78.2219L64.7535 56.0018C65.1331 55.8102 65.5523 55.7103 65.9774 55.7103C66.4026 55.7103 66.8218 55.8102 67.2013 56.0018L86.4241 67.1012C87.0972 67.4898 87.0972 68.1259 86.4241 68.5145L47.9415 90.7347Z",
    fill: "#F7F7FC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M86.424 68.5146L47.9415 90.7348C47.562 90.9264 47.1428 91.0262 46.7176 91.0262C46.2925 91.0262 45.8733 90.9264 45.4937 90.7348L26.271 79.6353C25.9176 79.4313 25.7516 79.1591 25.7694 78.8903H25.7661V79.4586C25.7798 79.6106 25.8339 79.7563 25.9226 79.8805C26.0114 80.0047 26.1316 80.1031 26.271 80.1653L45.4937 91.2646C45.8732 91.4563 46.2924 91.5562 46.7176 91.5562C47.1428 91.5562 47.562 91.4563 47.9415 91.2646L86.424 69.0447C86.5634 68.9824 86.6837 68.8841 86.7724 68.7598C86.8612 68.6356 86.9152 68.49 86.9289 68.3379V67.8079C86.9152 67.9599 86.8612 68.1055 86.7724 68.2298C86.6837 68.354 86.5634 68.4523 86.424 68.5146Z",
    fill: "url(#paint9_linear_835_138800)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M76.1213 61.1519L67.202 56.0018C66.8225 55.8102 66.4033 55.7103 65.9781 55.7103C65.553 55.7103 65.1337 55.8102 64.7542 56.0018L41.0005 69.7173H55.1442L67.4878 62.591L65.5367 61.4647H75.5796L76.1213 61.1519Z",
    fill: "url(#paint10_linear_835_138800)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M26.708 77.9702L29.896 77.9699L42.2393 70.8435L40.6446 69.9229L26.708 77.9702Z",
    fill: "url(#paint11_linear_835_138800)"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6353 24.7388L65.9774 31.8652V53.5717L53.6353 46.4455V24.7388Z",
    fill: "#D0D3F2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3218 24.7388L65.9785 31.8652V53.5717L78.3218 46.4455V24.7388Z",
    fill: "#BDC0E0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9774 17.6127L53.6353 24.7389L65.9774 31.8653L78.3207 24.7389L65.9774 17.6127Z",
    fill: "#F6F6FA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3418 38.2419L51.6839 45.3679V61.8244L39.3418 54.6977V38.2419Z",
    fill: "#F2BD42"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0269 38.2418L51.6836 45.3678V61.8242L64.0269 54.6976V38.2418Z",
    fill: "#D6952D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6839 31.1155L39.3418 38.2419L51.6839 45.3679L64.0272 38.2419L51.6839 31.1155Z",
    fill: "#F6F6FA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0469 52.6991L37.389 59.8258V70.0769L25.0469 62.951V52.6991Z",
    fill: "#D0D3F2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7325 52.6991L37.3892 59.8258V70.0769L49.7325 62.951V52.6991Z",
    fill: "#BDC0E0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M37.389 45.5731L25.0469 52.6988L37.389 59.8255L49.7323 52.6988L37.389 45.5731Z",
    fill: "#F6F6FA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M37.389 70.0769L33.7007 57.6961L25.0469 52.6991V62.951L37.389 70.0769Z",
    fill: "#F2F2F7"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M33.7007 57.6959H41.0775L49.7323 52.6988L37.389 45.5731L25.0469 52.6988L33.7007 57.6959Z",
    fill: "url(#paint12_linear_835_138800)"
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7524 67.2766L23.0948 74.403V78.3298L10.7524 71.2034V67.2766Z",
    fill: "#D0D3F2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4366 67.2766L23.0938 74.403V78.3298L35.4366 71.2034V67.2766Z",
    fill: "#BDC0E0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0948 60.1501L10.7524 67.2768L23.0948 74.4032L35.4376 67.2768L23.0948 60.1501Z",
    fill: "#F6F6FA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6781 75.2024L16.2653 70.4598L10.7524 67.2766V71.2034L17.6781 75.2024Z",
    fill: "#F2F2F7"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M24.605 65.6415L22.8561 64.6321H30.8569L23.0948 60.1501L10.7524 67.2768L16.2624 70.4581L24.605 65.6415Z",
    fill: "url(#paint13_linear_835_138800)"
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3418 34.3145L51.6839 41.4409V45.3679L39.3418 38.2414V34.3145Z",
    fill: "#5555C6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0267 34.3146L51.6836 41.441V45.368L64.0267 38.2416V34.3146Z",
    fill: "#4141AA"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6839 27.1881L39.3418 34.3145L51.6839 41.441L64.027 34.3145L51.6839 27.1881Z",
    fill: "#7F7FF4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6353 16.1263L65.9774 23.2528V31.8651L53.6353 24.7384V16.1263Z",
    fill: "#5555C6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3214 16.1266L65.9785 23.253V31.8653L78.3214 24.7386V16.1266Z",
    fill: "#4141AA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9774 9L53.6353 16.1264L65.9774 23.2529L78.3202 16.1264L65.9774 9Z",
    fill: "#7F7FF4"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9292 50.7709L80.2713 57.8975V61.8245L67.9292 54.6979V50.7709Z",
    fill: "#F2BD42"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6153 50.7711L80.2725 57.8978V61.8248L92.6153 54.6981V50.7711Z",
    fill: "#D18F2F"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2713 43.6451L67.9292 50.7713L80.2713 57.898L92.6141 50.7713L80.2713 43.6451Z",
    fill: "#F7D25C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9252 60.4697L76.5124 55.7271L67.9292 50.7709V54.6979L77.9252 60.4697Z",
    fill: "#F2F2F7"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M80.2713 43.6451L67.9292 50.7713L76.5124 55.7276L87.8921 49.1575L85.8305 47.9672H87.7574L80.2713 43.6451Z",
    fill: "url(#paint14_linear_835_138800)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M72.6542 78.9816L69.1694 76.9697L71.8561 75.4184C71.8724 75.41 71.8876 75.4009 71.9023 75.3916L71.916 75.3839L71.9156 75.3837C72.3801 75.0837 72.0179 74.4874 70.8277 73.8002C69.1158 72.8119 66.3401 72.0105 64.6279 72.0105C64.0324 72.0105 63.6447 72.1077 63.4634 72.2758L63.4601 72.2737L60.6879 73.8741C60.2629 74.0753 60.3165 74.4548 60.8448 74.9212L57.3732 76.9254C56.9169 76.8452 56.4549 76.8018 55.9916 76.7956C55.3963 76.7956 55.0084 76.8925 54.8273 77.0606L54.8238 77.0587L52.0518 78.6592C51.4593 78.9394 51.7914 79.5648 53.0504 80.2916C54.7625 81.2799 57.5383 82.0813 59.2501 82.0813C59.8219 82.0813 60.2016 81.9916 60.3916 81.8356L60.3921 81.8361L62.882 80.3986L66.541 82.5112L72.6542 78.9816Z",
    fill: "url(#paint15_linear_835_138800)"
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4731 70.1026C58.4731 71.8923 59.7291 74.068 61.2789 74.9629C62.8288 75.8575 64.085 75.1321 64.085 73.3429C64.085 71.5531 62.8288 69.3779 61.2789 68.4828C59.7291 67.5879 58.4729 68.3135 58.4731 70.1026ZM58.8948 70.3464C58.8948 68.8259 59.9619 68.2096 61.2789 68.9699C62.5957 69.7303 63.6631 71.5785 63.6631 73.0993C63.6631 74.6198 62.5957 75.2356 61.2789 74.4755C59.9619 73.7156 58.8948 71.8671 58.8948 70.3464Z",
    fill: "#D0D4F6"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2781 74.4756C59.9612 73.7157 58.894 71.8672 58.894 70.3464C58.894 68.826 59.9612 68.2096 61.2781 68.97C61.3306 69.0005 61.3824 69.0355 61.4343 69.0693C61.5087 69.8302 61.7452 70.5664 62.1281 71.2282C62.511 71.8899 63.0313 72.462 63.6539 72.9056C63.6574 72.9704 63.6623 73.0355 63.6623 73.0993C63.6623 74.6198 62.5949 75.2357 61.2781 74.4756Z",
    fill: "url(#paint16_linear_835_138800)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1787 69.9332C58.1787 71.9099 59.5668 74.314 61.2789 75.3021C62.991 76.2905 64.3789 75.4893 64.3789 73.5129C64.3789 71.5357 62.991 69.1318 61.2789 68.1435C59.5668 67.1549 58.1787 67.956 58.1787 69.9332ZM58.4731 70.1026C58.4731 68.3136 59.7295 67.588 61.2789 68.4829C62.8288 69.3775 64.085 71.5534 64.085 73.3429C64.085 75.1322 62.8285 75.8576 61.2789 74.963C59.7293 74.0681 58.4729 71.8924 58.4731 70.1026Z",
    fill: "#34318F"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4445 75.5327H63.4443L63.4481 75.5306L63.4445 75.5327Z",
    fill: "#342D6A"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5476 66.5098C62.1138 66.1331 62.9218 66.1588 63.8187 66.677C65.5311 67.6653 66.919 70.069 66.919 72.0464C66.919 73.0499 66.5607 73.7499 65.9842 74.0671L65.9844 74.0673L63.492 75.5063C64.0404 75.1772 64.3791 74.4886 64.3791 73.5128C64.3791 71.5357 62.9912 69.1317 61.2791 68.1434C60.3819 67.6252 59.574 67.5998 59.0078 67.9765L61.5476 66.5098Z",
    fill: "url(#paint17_linear_835_138800)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2023 68.7659C52.7158 68.485 52.7158 68.0256 53.2023 67.7449L57.3367 65.3575C57.6109 65.219 57.9137 65.1469 58.2209 65.1469C58.528 65.1469 58.8309 65.219 59.105 65.3575L63.14 67.6871C63.626 67.968 63.6262 68.4272 63.14 68.7078L59.0053 71.0952C58.731 71.2337 58.4281 71.3059 58.1209 71.3059C57.8137 71.3059 57.5107 71.2337 57.2365 71.0952L53.2023 68.7659Z",
    fill: "#C4C8E2"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2023 68.7659C52.7158 68.485 52.7158 68.0256 53.2023 67.7449L57.3367 65.3575C57.6109 65.219 57.9137 65.1469 58.2209 65.1469C58.528 65.1469 58.8309 65.219 59.105 65.3575L63.14 67.6871C63.626 67.968 63.6262 68.4272 63.14 68.7078L59.0053 71.0952C58.731 71.2337 58.4281 71.3059 58.1209 71.3059C57.8137 71.3059 57.5107 71.2337 57.2365 71.0952L53.2023 68.7659Z",
    fill: "#F7F7FC"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8401 68.2863C52.8562 68.3899 52.8978 68.4879 52.9611 68.5716C53.0243 68.6553 53.1072 68.722 53.2025 68.7658L57.2368 71.0952L57.2384 71.0961C57.5125 71.2341 57.8152 71.3059 58.1221 71.3058C58.429 71.3056 58.7315 71.2335 59.0055 71.0952L63.1402 68.7078C63.2404 68.663 63.3269 68.5924 63.3908 68.5032C63.4548 68.4141 63.494 68.3096 63.5043 68.2003L63.5048 68.2005L63.505 72.3478C63.5048 72.9268 63.0181 74.201 62.1887 74.6383L57.6162 77.2779C57.6071 77.2835 57.598 77.2888 57.589 77.2937L57.5733 77.3028L57.5731 77.301C57.2559 77.4681 56.8263 77.4364 56.3526 77.1632L54.0864 75.8548C52.7932 75.1082 52.8401 73.714 52.8401 73.0931V68.2863Z",
    fill: "url(#paint18_linear_835_138800)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M52.8401 68.2863C52.8562 68.3899 52.8978 68.4879 52.9611 68.5716C53.0243 68.6553 53.1072 68.722 53.2025 68.7658L57.2368 71.0952L57.2384 71.0961C57.5125 71.2341 57.8152 71.3059 58.1221 71.3058C58.429 71.3056 58.7315 71.2335 59.0055 71.0952L63.1402 68.7078C63.2404 68.663 63.3269 68.5924 63.3908 68.5032C63.4548 68.4141 63.494 68.3096 63.5043 68.2003L63.5048 68.2005L63.505 72.3478C63.5048 72.9268 63.0181 74.201 62.1887 74.6383L57.6162 77.2779C57.6071 77.2835 57.598 77.2888 57.589 77.2937L57.5733 77.3028L57.5731 77.301C57.2559 77.4681 56.8263 77.4364 56.3526 77.1632L54.0864 75.8548C52.7932 75.1082 52.8401 73.714 52.8401 73.0931V68.2863Z",
    fill: "url(#paint19_linear_835_138800)"
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0381 74.9797C50.0381 76.7695 51.294 78.945 52.8439 79.8398C54.3938 80.7347 55.6497 80.0093 55.6497 78.22C55.6497 76.4303 54.394 74.2548 52.8439 73.3602C51.294 72.4653 50.0381 73.1905 50.0381 74.9797ZM50.46 75.2231C50.46 73.7028 51.5271 73.087 52.8439 73.8469C54.1607 74.6077 55.228 76.4557 55.228 77.9762C55.228 79.497 54.1607 80.1128 52.8439 79.3527C51.5271 78.5923 50.46 76.7438 50.46 75.2231Z",
    fill: "#D0D4F6"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8434 79.353C51.5266 78.5927 50.4595 76.7442 50.4595 75.2235C50.4595 73.7032 51.5266 73.0873 52.8434 73.8472C52.8963 73.8778 52.9476 73.913 52.9996 73.9468C53.074 74.7077 53.3106 75.4438 53.6935 76.1055C54.0763 76.7673 54.5966 77.3393 55.2191 77.7831C55.2228 77.8474 55.2275 77.9127 55.2275 77.9766C55.2275 79.4973 54.1602 80.1132 52.8434 79.353Z",
    fill: "url(#paint20_linear_835_138800)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7437 74.8105C49.7437 76.7874 51.1318 79.1914 52.8439 80.18C54.556 81.1683 55.9439 80.3669 55.9439 78.3902C55.9439 76.4128 54.556 74.0094 52.8439 73.021C51.1318 72.0325 49.7437 72.8336 49.7437 74.8105ZM50.0381 74.9802C50.0381 73.1909 51.2942 72.466 52.8439 73.3606C54.3937 74.255 55.6497 76.4308 55.6497 78.2205C55.6497 80.0098 54.3937 80.7347 52.8439 79.8403C51.2942 78.9457 50.0381 76.7695 50.0381 74.9802Z",
    fill: "#34318F"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0075 80.41L55.0073 80.4097L55.0109 80.408L55.0075 80.41Z",
    fill: "#342D6A"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1116 71.3873C53.6778 71.0103 54.4855 71.0362 55.3829 71.5542C57.095 72.5425 58.4831 74.946 58.4831 76.9234C58.4831 77.9271 58.1246 78.6271 57.5484 78.9443H57.5486L55.0559 80.3832C55.6044 80.0541 55.9431 79.3655 55.9431 78.3898C55.9431 76.4124 54.5552 74.0089 52.8431 73.0206C51.9456 72.5024 51.1377 72.4768 50.5718 72.8537L53.1116 71.3873Z",
    fill: "url(#paint21_linear_835_138800)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0377 51.4703C56.9407 51.4036 56.8379 51.3458 56.7305 51.2978C56.6844 51.2775 56.6347 51.2666 56.5844 51.2656C56.534 51.2646 56.484 51.2735 56.4371 51.2918C56.3902 51.3101 56.3474 51.3376 56.3111 51.3725C56.2748 51.4074 56.2458 51.4491 56.2256 51.4953C56.2055 51.5414 56.1947 51.5911 56.1937 51.6414C56.1928 51.6918 56.2018 51.7418 56.2203 51.7886C56.2387 51.8355 56.2662 51.8782 56.3012 51.9145C56.3362 51.9507 56.378 51.9796 56.4242 51.9997C56.6985 52.1473 56.9422 52.3457 57.1424 52.5843C57.1739 52.6234 57.2129 52.656 57.257 52.6801C57.3011 52.7042 57.3495 52.7194 57.3995 52.7247C57.4495 52.7301 57.5001 52.7256 57.5483 52.7114C57.5966 52.6973 57.6416 52.6737 57.6807 52.6422C57.7199 52.6107 57.7524 52.5717 57.7765 52.5276C57.8006 52.4835 57.8158 52.435 57.8212 52.385C57.8266 52.335 57.822 52.2845 57.8079 52.2362C57.7937 52.188 57.7702 52.143 57.7386 52.1038C57.5345 51.8622 57.2987 51.6491 57.0377 51.4703ZM57.3615 53.9917C57.4556 53.9211 57.5431 53.8422 57.623 53.7558C57.6908 53.6805 57.7259 53.5814 57.7208 53.4802C57.7156 53.3791 57.6706 53.2841 57.5955 53.216C57.5205 53.148 57.4215 53.1125 57.3203 53.1173C57.2191 53.1221 57.1239 53.1668 57.0556 53.2416C56.8283 53.4545 56.5625 53.6221 56.2724 53.7355C56.2253 53.7529 56.182 53.7795 56.145 53.8136C56.1081 53.8477 56.0782 53.8888 56.0572 53.9345C56.0361 53.9802 56.0243 54.0295 56.0223 54.0798C56.0203 54.13 56.0282 54.1802 56.0456 54.2274C56.063 54.2746 56.0896 54.3179 56.1237 54.3548C56.1578 54.3917 56.1989 54.4216 56.2446 54.4426C56.2902 54.4637 56.3396 54.4756 56.3899 54.4776C56.4401 54.4795 56.4903 54.4716 56.5375 54.4542C56.8317 54.3378 57.1089 54.1823 57.3615 53.9917Z",
    fill: "#121244"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9914 59.886C63.8758 59.1396 64.1242 57.7011 63.6245 56.221C63.0054 54.3879 61.1672 52.3709 57.8637 52.2075C57.6536 52.1974 57.4481 52.2711 57.2923 52.4124C57.1365 52.5536 57.0432 52.751 57.0327 52.961C57.0223 53.1711 57.0956 53.3767 57.2367 53.5327C57.3777 53.6888 57.5749 53.7825 57.7849 53.7932C60.2923 53.9175 61.6683 55.3911 62.1201 56.7289C62.4331 57.6562 62.2802 58.4083 61.9674 58.6722C61.8064 58.808 61.706 59.0022 61.6882 59.212C61.6704 59.4219 61.7367 59.6302 61.8725 59.7911C62.0083 59.9521 62.2025 60.0525 62.4123 60.0703C62.6221 60.0881 62.8304 60.0218 62.9914 59.886Z",
    fill: "url(#paint22_linear_835_138800)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7146 53.0699C55.7584 53.1387 55.8229 53.1916 55.8988 53.2212C55.9747 53.2507 56.0581 53.2553 56.1368 53.2343C56.4433 53.1786 56.7576 53.1817 57.0629 53.2434C57.162 53.2654 57.2659 53.2472 57.3516 53.1927C57.4373 53.1382 57.4978 53.0519 57.5199 52.9528C57.5419 52.8537 57.5237 52.7498 57.4692 52.6641C57.4147 52.5784 57.3285 52.5179 57.2293 52.4958C56.8036 52.4074 56.3643 52.407 55.9384 52.4946C55.8804 52.5102 55.8268 52.5392 55.782 52.5794C55.7373 52.6195 55.7026 52.6696 55.6808 52.7256C55.659 52.7816 55.6507 52.842 55.6566 52.9018C55.6625 52.9616 55.6824 53.0192 55.7146 53.0699Z",
    fill: "#1E1C6B"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7368 61.0149L51.7377 61.0146C51.7377 61.0192 51.7368 61.0233 51.7368 61.0276V61.0149Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7361 61.0547C51.7485 61.162 51.7885 61.2642 51.8522 61.3514C51.9159 61.4386 52.0011 61.5079 52.0995 61.5524L56.1342 63.8815C56.4084 64.02 56.7113 64.0922 57.0184 64.0922C57.3256 64.0922 57.6285 64.02 57.9027 63.8815L64.24 60.2228C64.3406 60.1778 64.4275 60.1068 64.4916 60.0171C64.5558 59.9275 64.5949 59.8223 64.605 59.7125V67.1146C64.5951 67.2245 64.556 67.3298 64.4919 67.4196C64.4277 67.5095 64.3407 67.5805 64.24 67.6255L57.9027 71.2843C57.6285 71.4229 57.3256 71.4951 57.0184 71.4951C56.7112 71.4951 56.4083 71.4229 56.1342 71.2843L52.0995 68.9549C51.9942 68.9091 51.9042 68.8342 51.84 68.739C51.7758 68.6438 51.7401 68.5324 51.737 68.4176L51.7358 68.4178L51.7361 61.0547Z",
    fill: "url(#paint23_linear_835_138800)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1 61.5524C51.6138 61.2717 51.6138 60.812 52.1 60.5314L58.4378 56.8724C58.7119 56.734 59.0148 56.6619 59.3219 56.6619C59.6291 56.6619 59.9319 56.734 60.2061 56.8724L64.2405 59.2018C64.727 59.4827 64.727 59.9419 64.2405 60.2228L57.9033 63.8815C57.6291 64.02 57.3262 64.0922 57.019 64.0922C56.7118 64.0922 56.4089 64.02 56.1347 63.8815L52.1 61.5524Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M64.2401 59.2016L61.4203 57.5737C61.4036 57.5735 61.3865 57.5728 61.3697 57.5728H59.8632C59.1495 57.5728 58.2823 57.7396 57.9257 57.9457L54.0416 60.1881C53.6856 60.394 53.9742 60.5609 54.6873 60.5609L57.4229 62.1632C57.067 62.369 57.3555 62.5359 58.0686 62.5359H59.5756C59.7987 62.5359 60.0257 62.5315 60.2551 62.5235L64.2401 60.2226C64.7266 59.9417 64.7266 59.4825 64.2401 59.2016Z",
    fill: "url(#paint24_linear_835_138800)"
  }), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7024 56.6586C61.1315 55.8336 62.2902 56.5021 62.2902 58.1525V59.0222C62.2782 59.2463 62.2134 59.4644 62.1011 59.6588C61.9889 59.8532 61.8324 60.0183 61.6443 60.1408L57.7604 62.3832C57.4038 62.5888 57.1147 62.4222 57.1147 62.0105V61.1406C57.1147 59.4902 58.2735 57.4835 59.7024 56.6586Z",
    fill: "#BDC1E4"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3512 54.7231C57.0673 54.3094 57.7157 54.2716 58.184 54.5438L61.5313 56.476C61.0633 56.2072 60.4169 56.2466 59.7036 56.6585C58.2747 57.4834 57.116 59.4902 57.116 61.1405V62.0105C57.108 62.0896 57.1207 62.1694 57.153 62.2421C57.1853 62.3148 57.236 62.3778 57.3001 62.4249L53.9659 60.4993C53.8959 60.4545 53.8398 60.391 53.804 60.316C53.7683 60.241 53.7542 60.1574 53.7635 60.0748V59.2051C53.7635 57.555 54.9223 55.5483 56.3512 54.7231Z",
    fill: "url(#paint25_linear_835_138800)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M56.0793 65.9318L54.1568 63.8423L53.145 64.788L55.0677 66.8773L56.0793 65.9318Z",
    fill: "url(#paint26_linear_835_138800)"
  }), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6358 64.911C54.621 64.6358 54.5414 64.3679 54.4036 64.1293C54.2658 63.8906 54.0737 63.6878 53.8428 63.5373C53.4046 63.2844 53.0498 63.4893 53.0498 63.9951C53.0646 64.2703 53.1441 64.5382 53.2819 64.7769C53.4197 65.0156 53.6119 65.2184 53.8428 65.3688C54.2808 65.6217 54.6358 65.4163 54.6358 64.911ZM48.176 58.3131C48.2395 58.4122 48.3116 58.5055 48.3916 58.5919C48.4615 58.6653 48.5577 58.708 48.6591 58.7105C48.7605 58.7131 48.8587 58.6753 48.9323 58.6056C49.0059 58.5358 49.0488 58.4397 49.0516 58.3383C49.0544 58.2369 49.0169 58.1386 48.9473 58.0649C48.7523 57.822 48.6052 57.5442 48.514 57.2464C48.5003 57.198 48.4772 57.1527 48.446 57.1132C48.4147 57.0737 48.376 57.0407 48.3321 57.0162C48.2881 56.9916 48.2397 56.976 48.1897 56.9702C48.1397 56.9644 48.0891 56.9685 48.0406 56.9823C47.9922 56.9961 47.947 57.0193 47.9076 57.0506C47.8681 57.0819 47.8352 57.1207 47.8108 57.1647C47.7864 57.2087 47.7709 57.2571 47.7652 57.3071C47.7595 57.3572 47.7637 57.4078 47.7776 57.4562C47.8711 57.7585 48.0051 58.0468 48.176 58.3131Z",
    fill: "#121244"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6362 64.9374C54.6364 64.9285 54.6378 64.9203 54.6378 64.9112C54.6235 64.6607 54.5563 64.4161 54.4406 64.1935C54.3249 63.9709 54.1633 63.7753 53.9665 63.6197C53.9572 63.6185 53.9486 63.6161 53.939 63.6152C52.1532 64.2602 50.5507 63.3231 49.6738 62.0961C49.1314 61.3369 48.7246 60.1959 49.3647 59.4779C49.832 58.6476 48.9668 57.6744 48.1134 58.5276C47.2598 59.3812 47.281 61.3821 48.4276 62.9868C49.6474 64.693 52.0779 66.0597 54.533 65.0269C54.5696 64.9997 54.6042 64.9698 54.6362 64.9374Z",
    fill: "url(#paint27_linear_835_138800)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4025 59.4075C50.5195 59.3948 50.6351 59.3717 50.748 59.3385C50.7961 59.3238 50.8408 59.2997 50.8796 59.2677C50.9184 59.2357 50.9506 59.1964 50.9742 59.152C50.9978 59.1075 51.0124 59.0589 51.0172 59.0088C51.022 58.9587 51.0169 58.9082 51.0022 58.8601C50.9875 58.812 50.9634 58.7673 50.9314 58.7285C50.8994 58.6897 50.86 58.6575 50.8156 58.634C50.7712 58.6104 50.7225 58.5958 50.6724 58.591C50.6223 58.5862 50.5718 58.5913 50.5237 58.6061C50.2194 58.6726 49.9052 58.6807 49.5979 58.6301C49.5484 58.6209 49.4977 58.6215 49.4485 58.632C49.3993 58.6424 49.3526 58.6624 49.3112 58.6909C49.2697 58.7193 49.2343 58.7557 49.2069 58.7978C49.1795 58.84 49.1606 58.8872 49.1515 58.9366C49.1423 58.986 49.1429 59.0368 49.1533 59.086C49.1638 59.1352 49.1838 59.1818 49.2123 59.2233C49.2407 59.2647 49.2771 59.3002 49.3192 59.3276C49.3614 59.355 49.4085 59.3738 49.458 59.383C49.7703 59.4335 50.088 59.4417 50.4025 59.4075Z",
    fill: "#121244"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0788 58.6559C49.1597 58.6463 49.2354 58.6112 49.2949 58.5557C49.3545 58.5001 49.3948 58.4271 49.41 58.3471C49.4931 58.0468 49.6324 57.7651 49.8205 57.5168C49.8832 57.4371 49.9117 57.3358 49.8998 57.2351C49.8879 57.1345 49.8365 57.0426 49.757 56.9798C49.6774 56.9169 49.5762 56.8882 49.4755 56.8999C49.3748 56.9116 49.2828 56.9628 49.2198 57.0422C48.9552 57.3872 48.7638 57.7826 48.6576 58.2042C48.6387 58.304 48.6602 58.4072 48.7173 58.4912C48.7745 58.5752 48.8627 58.633 48.9625 58.652C49.0008 58.6591 49.04 58.6604 49.0788 58.6559Z",
    fill: "#1E1C6B"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5583 61.8718C60.5387 61.8718 60.5193 61.868 60.5012 61.8605C60.4831 61.853 60.4666 61.842 60.4528 61.8282C60.4389 61.8143 60.4279 61.7978 60.4204 61.7797C60.413 61.7616 60.4091 61.7422 60.4091 61.7226V61.1814C60.404 61.0521 60.3696 60.9257 60.3086 60.8116C60.2475 60.6975 60.1614 60.5988 60.0567 60.5228L59.6294 60.2762C59.6123 60.2665 59.5974 60.2534 59.5854 60.2379C59.5733 60.2223 59.5645 60.2046 59.5594 60.1856C59.5542 60.1666 59.5529 60.1468 59.5554 60.1273C59.558 60.1078 59.5644 60.089 59.5742 60.072C59.584 60.055 59.5971 60.04 59.6127 60.0281C59.6283 60.0161 59.6461 60.0074 59.6651 60.0023C59.6841 59.9972 59.7039 59.996 59.7234 59.9986C59.7428 60.0012 59.7616 60.0076 59.7786 60.0175L60.2059 60.2641C60.3565 60.366 60.4806 60.5024 60.5679 60.6619C60.6551 60.8215 60.703 60.9996 60.7075 61.1814V61.7226C60.7075 61.7422 60.7037 61.7616 60.6962 61.7797C60.6887 61.7978 60.6777 61.8143 60.6638 61.8282C60.65 61.842 60.6335 61.853 60.6154 61.8605C60.5973 61.868 60.5779 61.8718 60.5583 61.8718ZM61.3126 61.4401C61.293 61.4401 61.2736 61.4363 61.2555 61.4288C61.2374 61.4213 61.2209 61.4103 61.2071 61.3965C61.1932 61.3826 61.1822 61.3661 61.1747 61.348C61.1673 61.3299 61.1634 61.3105 61.1634 61.2909V60.7494C61.1583 60.6202 61.1239 60.4937 61.0629 60.3797C61.0018 60.2656 60.9157 60.1669 60.811 60.0909L60.384 59.8445C60.3669 59.8348 60.3519 59.8217 60.3399 59.8062C60.3279 59.7906 60.3191 59.7729 60.3139 59.7539C60.3088 59.7349 60.3075 59.7151 60.31 59.6956C60.3125 59.6761 60.3189 59.6573 60.3287 59.6403C60.3385 59.6233 60.3516 59.6083 60.3672 59.5964C60.3828 59.5844 60.4006 59.5757 60.4196 59.5706C60.4386 59.5655 60.4584 59.5643 60.4779 59.5669C60.4974 59.5695 60.5161 59.5759 60.5331 59.5858L60.9602 59.8322C61.1108 59.9341 61.2349 60.0704 61.3222 60.23C61.4094 60.3895 61.4573 60.5676 61.4618 60.7494V61.2909C61.4618 61.3105 61.458 61.3299 61.4505 61.348C61.443 61.3661 61.432 61.3826 61.4182 61.3965C61.4043 61.4103 61.3878 61.4213 61.3697 61.4288C61.3516 61.4363 61.3322 61.4401 61.3126 61.4401Z",
    fill: "#5555C6"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M122.428 56.8969L127.222 54.1293L118.797 49.2653L114.047 52.0077C113.981 52.007 113.916 52.0063 113.849 52.0063C110.51 52.0063 106.451 52.7876 104.782 53.7513C103.129 54.7053 104.44 55.4801 107.706 55.4955C107.59 55.7331 107.692 55.9995 108.015 56.1855L110.659 57.7125L112.869 58.988C112.044 59.786 113.444 60.3866 116.371 60.3866C119.71 60.3866 123.769 59.6055 125.438 58.6417C127.106 57.6792 125.758 56.8988 122.428 56.8969Z",
    fill: "url(#paint28_linear_835_138800)"
  }), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M106.539 48.1173C105.028 48.9898 103.804 51.1108 103.804 52.8557C103.804 54.6005 105.028 55.3075 106.539 54.435C108.051 53.5627 109.275 51.4413 109.275 49.6968C109.275 47.9518 108.051 47.2448 106.539 48.1173ZM106.539 53.9602C105.255 54.7014 104.215 54.1007 104.215 52.618C104.215 51.1357 105.255 49.3336 106.539 48.5924C107.823 47.8511 108.864 48.4518 108.864 49.9341C108.864 51.4168 107.823 53.2189 106.539 53.9602Z",
    fill: "#BDC1E4"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M106.54 53.9604C107.824 53.2191 108.865 51.417 108.865 49.9343C108.865 48.452 107.824 47.8513 106.54 48.5926C106.489 48.6219 106.438 48.6562 106.388 48.6893C106.315 49.4312 106.085 50.1489 105.711 50.7941C105.338 51.4393 104.831 51.997 104.224 52.4296C104.22 52.4925 104.216 52.5562 104.216 52.6182C104.216 54.1009 105.256 54.7016 106.54 53.9604Z",
    fill: "url(#paint29_linear_835_138800)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M106.539 47.7864C104.87 48.7501 103.517 51.0937 103.517 53.0214C103.517 54.9486 104.87 55.73 106.539 54.7664C108.209 53.8025 109.562 51.4587 109.562 49.5314C109.562 47.6037 108.209 46.8226 106.539 47.7864ZM106.539 54.4351C105.029 55.3074 103.804 54.6004 103.804 52.8559C103.804 51.1111 105.028 48.9897 106.539 48.1174C108.05 47.2452 109.275 47.9522 109.275 49.6969C109.275 51.4414 108.05 53.5629 106.539 54.4351Z",
    fill: "#1E1C6B"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M104.427 54.9911V54.9909L104.423 54.9891L104.427 54.9911Z",
    fill: "#342D6A"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M106.277 46.194C105.725 45.8266 104.937 45.8515 104.062 46.3567C102.393 47.3205 101.04 49.6641 101.04 51.5916C101.04 52.5701 101.389 53.2527 101.951 53.562V53.5622L104.381 54.965C103.846 54.6443 103.516 53.9727 103.516 53.0214C103.516 51.0937 104.869 48.7501 106.539 47.7865C107.413 47.2811 108.201 47.2562 108.753 47.6238L106.277 46.194Z",
    fill: "url(#paint30_linear_835_138800)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M104.624 40.3689C103.782 40.3246 102.879 40.7813 102.08 41.6545C101.185 42.6325 100.371 44.2374 100.568 45.619L102.046 45.4083C101.94 44.6663 102.428 43.4859 103.181 42.6626C103.659 42.1405 104.169 41.8402 104.545 41.8601L104.624 40.3689Z",
    fill: "url(#paint31_linear_835_138800)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M114.413 48.3933C114.887 48.1196 114.887 47.6716 114.413 47.398L110.382 45.0705C110.115 44.9355 109.819 44.8652 109.52 44.8652C109.221 44.8652 108.925 44.9355 108.658 45.0705L104.724 47.3416C104.25 47.6152 104.25 48.0632 104.724 48.3369L108.755 50.6644C109.023 50.7993 109.318 50.8697 109.617 50.8697C109.917 50.8697 110.212 50.7993 110.48 50.6644L114.413 48.3933Z",
    fill: "#C4C8E2"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M114.413 48.3933C114.887 48.1196 114.887 47.6716 114.413 47.398L110.382 45.0705C110.115 44.9355 109.819 44.8652 109.52 44.8652C109.221 44.8652 108.925 44.9355 108.658 45.0705L104.724 47.3416C104.25 47.6152 104.25 48.0632 104.724 48.3369L108.755 50.6644C109.023 50.7993 109.318 50.8697 109.617 50.8697C109.917 50.8697 110.212 50.7993 110.48 50.6644L114.413 48.3933Z",
    fill: "#F7F7FC"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M114.767 47.9257C114.751 48.0267 114.71 48.1222 114.649 48.2037C114.587 48.2852 114.506 48.3503 114.413 48.3931L110.48 50.6642L110.479 50.6649C110.211 50.7995 109.916 50.8695 109.617 50.8694C109.318 50.8693 109.023 50.799 108.756 50.6642L104.725 48.3367C104.627 48.2929 104.543 48.2241 104.48 48.1372C104.418 48.0503 104.379 47.9483 104.369 47.8418L104.369 51.8854C104.369 52.4502 104.843 53.6924 105.652 54.1187L110.11 56.6921C110.119 56.6977 110.128 56.7028 110.137 56.7077L110.152 56.7163L110.152 56.715C110.461 56.8776 110.88 56.8471 111.342 56.5802L113.551 55.3049C114.812 54.5767 114.767 53.2173 114.767 52.6122V47.9257Z",
    fill: "url(#paint32_linear_835_138800)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M114.767 47.9257C114.751 48.0267 114.71 48.1222 114.649 48.2037C114.587 48.2852 114.506 48.3503 114.413 48.3931L110.48 50.6642L110.479 50.6649C110.211 50.7995 109.916 50.8695 109.617 50.8694C109.318 50.8693 109.023 50.799 108.756 50.6642L104.725 48.3367C104.627 48.2929 104.543 48.2241 104.48 48.1372C104.418 48.0503 104.379 47.9483 104.369 47.8418L104.369 51.8854C104.369 52.4502 104.843 53.6924 105.652 54.1187L110.11 56.6921C110.119 56.6977 110.128 56.7028 110.137 56.7077L110.152 56.7163L110.152 56.715C110.461 56.8776 110.88 56.8471 111.342 56.5802L113.551 55.3049C114.812 54.5767 114.767 53.2173 114.767 52.6122V47.9257Z",
    fill: "url(#paint33_linear_835_138800)"
  }), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M114.763 52.8725C113.252 53.745 112.027 55.866 112.027 57.611C112.027 59.3557 113.252 60.0627 114.763 59.1905C116.274 58.318 117.499 56.1968 117.499 54.452C117.499 52.7073 116.274 52.0003 114.763 52.8725ZM114.763 58.7154C113.479 59.4566 112.439 58.856 112.439 57.3732C112.439 55.8909 113.479 54.0888 114.763 53.3476C116.047 52.6064 117.087 53.207 117.087 54.6895C117.087 56.172 116.047 57.9741 114.763 58.7154Z",
    fill: "#BDC1E4"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M114.764 58.7155C116.048 57.9742 117.089 56.1722 117.089 54.6896C117.089 53.2071 116.048 52.6064 114.764 53.3477C114.713 53.3771 114.663 53.4113 114.612 53.4444C114.54 54.1863 114.309 54.904 113.936 55.5492C113.562 56.1944 113.055 56.7521 112.448 57.1847C112.445 57.2477 112.44 57.3113 112.44 57.3733C112.44 58.8561 113.481 59.4567 114.764 58.7155Z",
    fill: "url(#paint34_linear_835_138800)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M114.763 52.5419C113.093 53.5055 111.74 55.8491 111.74 57.7768C111.74 59.7041 113.093 60.4854 114.763 59.5218C116.432 58.5579 117.785 56.2141 117.785 54.2869C117.785 52.3594 116.432 51.578 114.763 52.5419ZM114.763 59.1908C113.252 60.0631 112.027 59.3558 112.027 57.6113C112.027 55.8666 113.252 53.7451 114.763 52.8729C116.273 52.0006 117.498 52.7076 117.498 54.4524C117.498 56.1969 116.273 58.3183 114.763 59.1908Z",
    fill: "#1E1C6B"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M112.65 59.7463V59.7461L112.646 59.7444L112.65 59.7463Z",
    fill: "#342D6A"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M114.5 50.9491C113.948 50.5818 113.161 50.6069 112.286 51.112C110.617 52.0757 109.264 54.4193 109.264 56.3468C109.264 57.3255 109.613 58.0078 110.175 58.3171V58.3174L112.605 59.7204C112.07 59.3994 111.74 58.7279 111.74 57.7766C111.74 55.8489 113.093 53.5053 114.762 52.5416C115.637 52.0365 116.425 52.0113 116.977 52.379L114.5 50.9491Z",
    fill: "url(#paint35_linear_835_138800)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M115.842 40.8365L115.841 40.8363C115.841 40.8406 115.842 40.8447 115.842 40.849V40.8365Z",
    fill: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M115.841 40.8754C115.829 40.9799 115.79 41.0796 115.728 41.1646C115.666 41.2496 115.583 41.3171 115.487 41.3605L111.553 43.6316C111.286 43.7665 110.99 43.8368 110.691 43.8368C110.391 43.8368 110.096 43.7665 109.829 43.6316L103.65 40.0642C103.552 40.0204 103.467 39.9512 103.405 39.8637C103.342 39.7763 103.304 39.6738 103.294 39.5668V46.7833C103.304 46.8905 103.342 46.9932 103.404 47.0808C103.467 47.1684 103.552 47.2377 103.65 47.2817L109.829 50.8488C110.096 50.9838 110.391 51.0542 110.691 51.0542C110.99 51.0542 111.286 50.9838 111.553 50.8488L115.487 48.5777C115.589 48.533 115.677 48.46 115.74 48.3672C115.802 48.2745 115.837 48.1658 115.84 48.0539L115.841 48.0541L115.841 40.8754Z",
    fill: "url(#paint36_linear_835_138800)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M115.487 41.3604C115.961 41.0867 115.961 40.6387 115.487 40.3648L109.308 36.7976C109.041 36.6626 108.745 36.5923 108.446 36.5923C108.146 36.5923 107.851 36.6626 107.584 36.7976L103.65 39.0685C103.176 39.3424 103.176 39.7902 103.65 40.0641L109.829 43.6314C110.096 43.7664 110.391 43.8367 110.691 43.8367C110.99 43.8367 111.286 43.7664 111.553 43.6314L115.487 41.3604Z",
    fill: "#F7F7FC"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M101.01 45.6006C100.96 45.6389 100.901 45.6638 100.839 45.673C100.777 45.6822 100.713 45.6754 100.655 45.6532C100.363 45.5925 100.061 45.5935 99.7698 45.656C99.722 45.6656 99.6728 45.6656 99.6249 45.6562C99.5771 45.6467 99.5316 45.6279 99.4911 45.6008C99.4505 45.5737 99.4157 45.5389 99.3886 45.4984C99.3615 45.4579 99.3427 45.4124 99.3332 45.3645C99.3238 45.3167 99.3238 45.2675 99.3334 45.2197C99.343 45.1719 99.3619 45.1264 99.389 45.086C99.4162 45.0455 99.4511 45.0107 99.4917 44.9838C99.5323 44.9568 99.5778 44.9381 99.6257 44.9287C100.052 44.8388 100.494 44.8492 100.915 44.959C100.977 44.9822 101.032 45.0216 101.074 45.0731C101.115 45.1246 101.142 45.1863 101.152 45.2518C101.162 45.3173 101.154 45.3842 101.129 45.4456C101.104 45.5069 101.063 45.5605 101.01 45.6006Z",
    fill: "#121244"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M101.304 50.2465C100.531 49.8006 100.145 49.2153 100.147 48.6302L100.15 46.0936C100.149 46.6787 100.535 47.264 101.307 47.7106C102.843 48.5971 105.324 48.5971 106.85 47.7113C107.607 47.2701 107.987 46.6941 107.989 46.1167L107.985 48.6528C107.984 49.2302 107.604 49.8062 106.846 50.2472C105.321 51.1337 102.839 51.1337 101.304 50.2465Z",
    fill: "url(#paint37_linear_835_138800)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M101.305 47.7106C99.77 46.8241 99.7618 45.3868 101.287 44.5004C102.813 43.6137 105.295 43.6137 106.83 44.5004C108.366 45.3868 108.373 46.8241 106.848 47.7113C105.323 48.5971 102.841 48.5971 101.305 47.7106Z",
    fill: "#F2F2F7"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M102.839 47.1127L102.292 46.7964L104.406 45.5756L103.55 45.3146L103.992 45.0596L105.544 45.4831L105.603 45.517L102.839 47.1127Z",
    fill: "#D3D8F2"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M107.39 50.3104C107.275 50.3113 107.161 50.3021 107.048 50.2826C106.999 50.2741 106.953 50.2561 106.911 50.2296C106.87 50.2031 106.834 50.1687 106.806 50.1282C106.778 50.0878 106.758 50.0423 106.747 49.9942C106.737 49.946 106.736 49.8963 106.745 49.8479C106.754 49.7995 106.772 49.7533 106.799 49.7119C106.826 49.6706 106.86 49.635 106.901 49.6071C106.941 49.5793 106.987 49.5597 107.035 49.5496C107.084 49.5395 107.133 49.539 107.182 49.5481C107.484 49.5779 107.789 49.5501 108.081 49.4661C108.128 49.4516 108.177 49.4464 108.226 49.4509C108.275 49.4554 108.322 49.4695 108.365 49.4924C108.409 49.5152 108.447 49.5464 108.478 49.5841C108.51 49.6218 108.533 49.6653 108.548 49.7121C108.562 49.7589 108.568 49.8081 108.563 49.8569C108.559 49.9058 108.544 49.9532 108.522 49.9966C108.499 50.0399 108.468 50.0784 108.43 50.1097C108.392 50.141 108.349 50.1646 108.302 50.1791C108.005 50.2637 107.698 50.3079 107.39 50.3104Z",
    fill: "#121244"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M115.385 46.086L113.193 44.396L114.025 43.3331L116.218 45.0231L115.385 46.086Z",
    fill: "url(#paint38_linear_835_138800)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M115.489 40.3649L111.575 38.1053H110.118C109.056 38.1053 108.624 38.3549 109.155 38.6614L107.042 39.8059C105.98 39.8059 105.548 40.0553 106.079 40.3621L109.399 42.2789C109.93 42.5856 111.227 42.8351 112.289 42.8351H112.934L115.489 41.3605C115.963 41.0868 115.963 40.6388 115.489 40.3649Z",
    fill: "url(#paint39_linear_835_138800)"
  }), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M108.35 49.7353C108.27 49.7353 108.193 49.7099 108.129 49.6629C108.065 49.6159 108.018 49.5498 107.994 49.474C107.879 49.1927 107.712 48.9356 107.502 48.7164C107.467 48.6818 107.44 48.6406 107.421 48.5953C107.402 48.55 107.392 48.5014 107.392 48.4523C107.392 48.4032 107.402 48.3546 107.42 48.3093C107.439 48.2639 107.467 48.2227 107.501 48.188C107.536 48.1533 107.577 48.1258 107.623 48.107C107.668 48.0883 107.717 48.0787 107.766 48.0787C107.815 48.0788 107.864 48.0885 107.909 48.1074C107.954 48.1263 107.995 48.1539 108.03 48.1887C108.325 48.4926 108.555 48.8538 108.706 49.25C108.721 49.2968 108.726 49.346 108.722 49.3948C108.717 49.4436 108.704 49.4911 108.681 49.5346C108.658 49.5781 108.627 49.6166 108.59 49.6481C108.552 49.6796 108.509 49.7034 108.462 49.7181C108.426 49.7296 108.388 49.7354 108.35 49.7353Z",
    fill: "#121244"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M113.015 44.6348C113.029 44.3665 113.107 44.1054 113.241 43.8727C113.375 43.6399 113.563 43.4422 113.788 43.2954C114.215 43.049 114.561 43.249 114.561 43.7418C114.547 44.0102 114.469 44.2713 114.335 44.504C114.2 44.7367 114.013 44.9345 113.788 45.0812C113.361 45.3278 113.015 45.1278 113.015 44.6348Z",
    fill: "#1E1C6B"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M114.451 43.7589C114.296 43.569 114.13 43.3896 113.952 43.2218C113.895 43.2407 113.84 43.2655 113.788 43.2957C113.408 43.5448 113.141 43.9333 113.044 44.3775C113.091 44.4888 113.154 44.5926 113.231 44.6854C113.855 45.3854 113.458 46.498 112.929 47.2381C112.075 48.4344 110.512 49.3479 108.771 48.7192C107.885 48.811 107.62 49.6768 108.192 50.0954C110.586 51.1024 112.955 49.77 114.145 48.1064C115.262 46.5421 115.324 44.7535 114.451 43.7589Z",
    fill: "url(#paint40_linear_835_138800)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M106.078 40.3619C105.797 40.1789 105.564 39.9325 105.397 39.6426C105.229 39.3526 105.133 39.0274 105.114 38.6932V36.7947C105.114 36.1813 105.546 35.9318 106.078 36.2385L109.398 38.1553C109.678 38.3383 109.911 38.5847 110.079 38.8746C110.246 39.1645 110.343 39.4897 110.361 39.8239V41.7225C110.361 42.3358 109.929 42.5855 109.398 42.2787L106.078 40.3619Z",
    fill: "#D0D4F6"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M106.399 39.8057C106.212 39.6834 106.057 39.5191 105.945 39.3258C105.834 39.1326 105.769 38.9159 105.757 38.6931V36.7946C105.754 36.701 105.774 36.6081 105.814 36.5235C105.591 36.5118 105.436 36.6805 105.436 36.9801V38.8786C105.448 39.1014 105.513 39.3181 105.624 39.5113C105.736 39.7045 105.891 39.8688 106.078 39.991L109.398 41.9078C109.657 42.0576 109.881 42.0068 109.982 41.8082C109.889 41.8008 109.799 41.7714 109.719 41.7224L106.399 39.8057Z",
    fill: "url(#paint41_linear_835_138800)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M110.04 39.6387C110.027 39.4159 109.963 39.1992 109.851 39.0059C109.74 38.8127 109.584 38.6483 109.398 38.5261L106.078 36.6093C106.067 36.5855 106.051 36.5641 106.032 36.5466C106.013 36.5291 105.99 36.5159 105.965 36.5078C105.94 36.4997 105.914 36.4969 105.888 36.4997C105.862 36.5024 105.837 36.5106 105.814 36.5236C105.791 36.5367 105.772 36.5544 105.756 36.5755C105.741 36.5967 105.73 36.6208 105.725 36.6464C105.719 36.6719 105.719 36.6983 105.725 36.7239C105.73 36.7495 105.741 36.7736 105.756 36.7947V38.6932C105.769 38.916 105.833 39.1327 105.945 39.326C106.057 39.5192 106.212 39.6836 106.399 39.8058L109.719 41.7226C109.729 41.7464 109.745 41.7678 109.764 41.7853C109.784 41.8028 109.807 41.816 109.831 41.8241C109.856 41.8322 109.883 41.835 109.909 41.8323C109.934 41.8295 109.96 41.8214 109.982 41.8083C110.005 41.7952 110.025 41.7776 110.04 41.7564C110.055 41.7353 110.066 41.7112 110.071 41.6856C110.077 41.66 110.077 41.6336 110.071 41.6081C110.066 41.5825 110.055 41.5584 110.04 41.5373V39.6387Z",
    fill: "url(#paint42_linear_835_138800)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M106.069 39.4284V37.5298C106.069 37.2304 106.225 37.0615 106.447 37.0733C106.541 37.0808 106.631 37.1102 106.711 37.1591L109.816 38.9515C109.712 38.7787 109.568 38.633 109.398 38.5261L106.078 36.6093C106.067 36.5855 106.051 36.5641 106.032 36.5466C106.013 36.5291 105.99 36.5159 105.965 36.5078C105.94 36.4997 105.914 36.4969 105.888 36.4997C105.862 36.5024 105.837 36.5106 105.814 36.5236C105.791 36.5367 105.772 36.5544 105.756 36.5755C105.741 36.5967 105.73 36.6208 105.725 36.6464C105.719 36.6719 105.719 36.6983 105.725 36.7239C105.73 36.7495 105.741 36.7736 105.756 36.7947V38.6932C105.772 38.9943 105.884 39.2824 106.076 39.5149C106.073 39.486 106.069 39.4566 106.069 39.4284Z",
    fill: "url(#paint43_linear_835_138800)"
  }), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M105.354 36.2019L105.355 36.2009L105.354 36.2019Z",
    fill: "#BDC1E4"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M112.225 36.5227L108.905 34.6058C108.802 34.5281 108.678 34.483 108.549 34.4764C108.42 34.4698 108.292 34.502 108.181 34.5689L105.443 36.1498C105.548 36.1136 105.66 36.1028 105.771 36.1182C105.881 36.1337 105.986 36.175 106.077 36.2388L109.397 38.1556C109.677 38.3386 109.911 38.585 110.078 38.8749C110.245 39.1648 110.342 39.49 110.361 39.8242V41.7228C110.369 41.8305 110.354 41.9389 110.315 42.0397C110.276 42.1406 110.215 42.2315 110.136 42.3056C110.136 42.3056 112.927 40.7025 112.964 40.6734L112.965 40.6727V40.6725C113.043 40.5984 113.104 40.5076 113.143 40.4067C113.182 40.3059 113.197 40.1976 113.189 40.09V38.1913C113.17 37.857 113.074 37.5319 112.906 37.242C112.739 36.9521 112.506 36.7057 112.225 36.5227Z",
    fill: "url(#paint44_linear_835_138800)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M107.314 38.6035L106.805 38.3099V38.0629L107.314 38.3565V38.6035Z",
    fill: "#F3B378"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M109.313 39.7585L108.805 39.4649V39.2177L109.313 39.5112V39.7585Z",
    fill: "#F3B378"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M108.403 40.0288L107.513 39.5149V39.2676L108.403 39.7815V40.0288Z",
    fill: "#F3B378"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M115.831 73.2117C114.915 72.7288 113.887 72.5012 112.853 72.553H109.94V72.8274C109.631 72.923 109.334 73.0519 109.053 73.2117C107.528 74.0989 107.537 75.536 109.071 76.4227C109.347 76.5788 109.638 76.7051 109.94 76.7994V77.0863H113.187C114.116 77.0896 115.031 76.8617 115.849 76.4234C117.374 75.536 117.367 74.0989 115.831 73.2117Z",
    fill: "url(#paint45_linear_835_138800)"
  }), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M107.374 76.4212C106.601 75.9753 106.215 75.39 106.217 74.8049L106.22 72.2683C106.219 72.8534 106.604 73.4387 107.377 73.8853C108.913 74.7718 111.394 74.7718 112.92 73.886C113.677 73.4448 114.057 72.8688 114.058 72.2914L114.055 74.8275C114.053 75.4049 113.674 75.9809 112.916 76.4219C111.391 77.3084 108.909 77.3084 107.374 76.4212Z",
    fill: "url(#paint46_linear_835_138800)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M107.375 73.8853C105.84 72.9988 105.832 71.5615 107.357 70.675C108.883 69.7883 111.365 69.7883 112.9 70.675C114.436 71.5615 114.443 72.9988 112.918 73.886C111.392 74.7717 108.911 74.7717 107.375 73.8853Z",
    fill: "#F2F2F7"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M112.233 73.2275C112.783 73.2198 113.33 73.1406 113.86 72.992C114.304 72.2035 113.987 71.3017 112.9 70.6748C111.365 69.7881 108.883 69.7881 107.357 70.6748C107.218 70.7561 107.086 70.8477 106.961 70.9488C106.96 71.533 107.345 72.118 108.117 72.5638C108.392 72.7199 108.683 72.8462 108.986 72.9405V73.2275H112.233Z",
    fill: "url(#paint47_linear_835_138800)"
  }), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M106.419 72.5621C105.647 72.1161 105.261 71.5308 105.262 70.9458L105.265 68.4092C105.264 68.9942 105.65 69.5796 106.422 70.0262C107.958 70.9127 110.44 70.9127 111.965 70.0269C112.723 69.5856 113.102 69.0096 113.104 68.4323L113.1 70.9684C113.099 71.5458 112.719 72.1218 111.962 72.5628C110.436 73.4492 107.955 73.4492 106.419 72.5621Z",
    fill: "url(#paint48_linear_835_138800)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M106.421 70.0262C104.885 69.1397 104.877 67.7024 106.402 66.8159C107.928 65.9292 110.41 65.9292 111.945 66.8159C113.481 67.7024 113.488 69.1397 111.963 70.0268C110.438 70.9126 107.957 70.9126 106.421 70.0262Z",
    fill: "#F7D25C"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M108.074 69.3522L107.526 69.036L109.641 67.8151L108.785 67.5541L109.227 67.2991L110.779 67.7226L110.838 67.7566L108.074 69.3522Z",
    fill: "#F2BD42"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M93.8139 80.1137C92.8982 79.6307 91.8695 79.4032 90.8356 79.455H87.923V79.7293C87.6141 79.825 87.3166 79.9538 87.0355 80.1137C85.5106 81.0009 85.5195 82.438 87.054 83.3246C87.3294 83.4808 87.6207 83.607 87.923 83.7013V83.9883H91.17C92.0987 83.9915 93.0136 83.7637 93.8323 83.3254C95.3572 82.438 95.3497 81.0009 93.8139 80.1137Z",
    fill: "url(#paint49_linear_835_138800)"
  }), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3563 83.3229C84.5836 82.877 84.1976 82.2917 84.1992 81.7066L84.2025 79.17C84.2011 79.7551 84.5869 80.3404 85.3594 80.787C86.8952 81.6735 89.3766 81.6735 90.902 80.7877C91.6595 80.3465 92.039 79.7705 92.0409 79.1931L92.0374 81.7292C92.0358 82.3066 91.6565 82.8826 90.8987 83.3236C89.3733 84.2101 86.8917 84.2101 85.3563 83.3229Z",
    fill: "url(#paint50_linear_835_138800)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3601 80.7873C83.8247 79.9008 83.8165 78.4635 85.3415 77.577C86.8676 76.6903 89.3496 76.6903 90.8846 77.577C92.4204 78.4635 92.4279 79.9008 90.9027 80.7879C89.3773 81.6737 86.896 81.6737 85.3601 80.7873Z",
    fill: "#F2F2F7"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8952 79.8463C88.5573 80.0524 88.1767 80.1786 87.7825 80.2151C87.4349 80.2435 87.087 80.1648 86.7854 79.9897C86.4846 79.816 86.3538 79.626 86.393 79.4195C86.4322 79.213 86.635 79.0017 87.0015 78.7858L87.5095 78.4925C87.8485 78.285 88.231 78.1589 88.627 78.1242C88.9724 78.098 89.3176 78.1768 89.6175 78.3502C89.9182 78.5239 90.0494 78.7137 90.0108 78.9199C89.9723 79.126 89.7697 79.337 89.4033 79.553L88.8952 79.8463ZM88.906 79.2075C89.0706 79.1331 89.2113 79.0144 89.3123 78.8646C89.354 78.7683 89.3085 78.6818 89.1758 78.6052C89.0443 78.5303 88.8911 78.5025 88.7417 78.5264C88.5424 78.5625 88.3515 78.6346 88.178 78.7391L87.5064 79.1269C87.3419 79.2032 87.2005 79.3215 87.0963 79.4698C87.0483 79.5683 87.0919 79.6566 87.2271 79.7347C87.3624 79.8123 87.521 79.8394 87.6745 79.8113C87.8777 79.7702 88.0722 79.6941 88.2494 79.5865L88.906 79.2075Z",
    fill: "#D3D8F2"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M47.9308 80.9582C47.0153 80.4752 45.9866 80.2476 44.9528 80.2995H42.04V80.5738C41.7312 80.6694 41.4337 80.7983 41.1528 80.9582C39.6278 81.8454 39.6367 83.2824 41.171 84.1691C41.4464 84.3252 41.7378 84.4514 42.04 84.5458V84.8328H45.287C46.2158 84.836 47.1307 84.6082 47.9495 84.1699C49.4744 83.2824 49.467 81.8454 47.9308 80.9582Z",
    fill: "url(#paint51_linear_835_138800)"
  }), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4726 84.1671C38.6996 83.7211 38.3136 83.1358 38.3154 82.5507L38.3187 80.0142C38.3173 80.5992 38.7029 81.1845 39.4753 81.6312C41.0115 82.5177 43.4926 82.5177 45.018 81.6319C45.7756 81.1906 46.155 80.6146 46.1569 80.0373L46.1536 82.5734C46.1518 83.1507 45.7727 83.7267 45.0147 84.1677C43.4893 85.0542 41.0077 85.0542 39.4726 84.1671Z",
    fill: "url(#paint52_linear_835_138800)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4738 81.6312C37.9386 80.7448 37.9302 79.3075 39.4551 78.421C40.9815 77.5343 43.4635 77.5343 44.9982 78.421C46.5344 79.3075 46.5418 80.7448 45.0164 81.6319C43.491 82.5177 41.0099 82.5177 39.4738 81.6312Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5019 81.2431C40.7289 80.7972 40.3429 80.2119 40.3447 79.6268L40.348 77.0902C40.3466 77.6753 40.7322 78.2606 41.5046 78.7072C43.0408 79.5937 45.5219 79.5937 47.0473 78.7079C47.8048 78.2667 48.1843 77.6907 48.1862 77.1133L48.1829 79.6494C48.1811 80.2268 47.802 80.8028 47.044 81.2438C45.5186 82.1303 43.037 82.1303 41.5019 81.2431Z",
    fill: "url(#paint53_linear_835_138800)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5031 78.7071C39.9679 77.8206 39.9595 76.3833 41.4844 75.4968C43.0108 74.6101 45.4928 74.6101 47.0275 75.4968C48.5637 76.3833 48.5711 77.8206 47.0457 78.7078C45.5203 79.5935 43.0392 79.5935 41.5031 78.7071Z",
    fill: "#7F7FF4"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9592 77.7787C44.6213 77.9848 44.2406 78.111 43.8465 78.1475C43.4989 78.1759 43.1509 78.0972 42.8494 77.9221C42.5486 77.7484 42.4178 77.5583 42.457 77.3518C42.4962 77.1454 42.699 76.9341 43.0655 76.7182L43.5735 76.4248C43.9125 76.2173 44.295 76.0913 44.691 76.0566C45.0364 76.0303 45.3816 76.1091 45.6814 76.2826C45.9822 76.4562 46.1133 76.6461 46.0748 76.8522C46.0363 77.0583 45.8337 77.2694 45.4672 77.4854L44.9592 77.7787ZM44.97 77.1399C45.1346 77.0655 45.2752 76.9468 45.3762 76.797C45.418 76.7007 45.3725 76.6142 45.2398 76.5376C45.1083 76.4627 44.9551 76.4349 44.8057 76.4588C44.6064 76.4949 44.4154 76.5669 44.242 76.6715L43.5704 77.0593C43.4059 77.1356 43.2645 77.2539 43.1603 77.4022C43.1122 77.5007 43.1558 77.589 43.2911 77.6671C43.4264 77.7447 43.5849 77.7718 43.7384 77.7436C43.9416 77.7025 44.1362 77.6265 44.3134 77.5189L44.97 77.1399Z",
    fill: "#6A6AE2"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M109.082 32.2909L111.543 33.7118L109.082 35.1325L106.621 33.7118L109.082 32.2909Z",
    fill: "#F7D25C"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M109.082 35.1326V36.4521L106.621 33.7119L109.082 35.1326Z",
    fill: "#F2BD42"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M109.081 36.4521L111.542 33.7119L109.081 35.1326V36.4521Z",
    fill: "#D6952D"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M109.081 36.452L111.072 35.856L112.104 36.452H109.081Z",
    fill: "url(#paint54_linear_835_138800)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M70.8239 14.5723C69.9318 14.1017 68.9293 13.88 67.9219 13.9304H65.9783V14.1981C65.6773 14.291 65.3874 14.4165 65.1137 14.5723C63.628 15.4365 63.6366 16.8369 65.1319 17.7007C65.4002 17.8528 65.6839 17.9759 65.9783 18.068V18.3474H68.2478C69.1526 18.3506 70.0441 18.1285 70.8416 17.7011C72.3274 16.8369 72.3202 15.4365 70.8239 14.5723Z",
    fill: "url(#paint55_linear_835_138800)"
  }), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M63.449 16.0998C62.6959 15.6649 62.3201 15.0946 62.3213 14.5249L62.3248 13.7234C62.3232 14.2937 62.6991 14.8636 63.4518 15.2989C64.9483 16.1621 67.3658 16.1621 68.8523 15.2989C69.5905 14.8698 69.9597 14.3082 69.9618 13.7459L69.9585 14.5468C69.9569 15.1093 69.5874 15.6705 68.849 16.0999C67.3628 16.9641 64.9453 16.9641 63.449 16.0998Z",
    fill: "url(#paint56_linear_835_138800)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M63.449 16.9006C62.6959 16.4659 62.3201 15.8954 62.3213 15.3257L62.3248 14.5242C62.3232 15.0946 62.6991 15.6644 63.4518 16.0998C64.9483 16.9629 67.3658 16.9629 68.8523 16.0998C69.5905 15.6707 69.9597 15.109 69.9618 14.5468L69.9585 15.3476C69.9569 15.91 69.5874 16.4712 68.849 16.901C67.3628 17.7651 64.9453 17.7651 63.449 16.9006Z",
    fill: "url(#paint57_linear_835_138800)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M63.449 17.7014C62.6959 17.2668 62.3201 16.6962 62.3213 16.1265L62.3248 15.325C62.3232 15.8954 62.6991 16.4655 63.4518 16.9006C64.9483 17.7639 67.3658 17.7639 68.8523 16.9006C69.5905 16.4715 69.9597 15.91 69.9618 15.3476L69.9585 16.1484C69.9569 16.7111 69.5874 17.2723 68.849 17.7019C67.3628 18.5661 64.9453 18.5661 63.449 17.7014Z",
    fill: "url(#paint58_linear_835_138800)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4519 15.2988C61.9563 14.4351 61.9477 13.034 63.4339 12.171C64.9206 11.3071 67.3386 11.3071 68.8344 12.171C70.3308 13.034 70.3383 14.4351 68.8523 15.2988C67.3658 16.162 64.9484 16.162 63.4519 15.2988Z",
    fill: "#F7F7FC"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1436 13.6462L65.3915 13.7861L65.4767 13.1674H64.7165L64.5103 14.2949L68.1436 14.0851V13.6462Z",
    fill: "#BFC3DD"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4995 50.5632L34.4846 51.1317C35.9834 50.2662 38.4137 50.2662 39.9125 51.1317C41.4116 51.9972 41.4116 53.4005 39.9125 54.2658C38.4137 55.1312 35.9834 55.1312 34.4846 54.2658L33.4995 54.8345C35.5424 56.0138 38.8545 56.014 40.8976 54.8345C42.9405 53.655 42.9405 51.7427 40.8976 50.5632C38.8545 49.3837 35.5424 49.3837 33.4995 50.5632Z",
    fill: "#DCE0F1"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M34.484 51.1315L33.499 50.563C31.4561 51.7425 31.4561 53.6548 33.499 54.8343L34.484 54.2656C32.9847 53.4003 32.9847 51.997 34.484 51.1315Z",
    fill: "#C6CAE3"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7777 53.3848C35.5464 53.3757 35.3208 53.3102 35.1206 53.1939C34.9173 53.0762 34.8074 52.9496 34.7907 52.8142C34.774 52.6787 34.8548 52.5599 35.0322 52.4573C35.2206 52.3523 35.4349 52.3032 35.6502 52.3158C35.8829 52.3231 36.1101 52.3886 36.311 52.5063C36.5173 52.6254 36.6275 52.7526 36.6415 52.8878C36.656 53.0233 36.5742 53.1422 36.3961 53.2447C36.2077 53.3499 35.993 53.3986 35.7777 53.3848ZM36.26 52.9055C36.2095 52.8027 36.1243 52.721 36.0194 52.675C35.8979 52.6003 35.7616 52.553 35.6199 52.5363C35.5028 52.5209 35.3838 52.5436 35.2805 52.6009C35.1882 52.654 35.1528 52.7191 35.1742 52.796C35.1954 52.8724 35.2733 52.9491 35.4087 53.0275C35.5309 53.1014 35.6678 53.1476 35.8099 53.1629C35.9261 53.1784 36.0444 53.1568 36.1476 53.1011C36.2446 53.0452 36.2823 52.9801 36.26 52.9055ZM36.5492 51.61L36.8975 51.4091L37.6856 53.8251L37.3378 54.0265L36.5492 51.61ZM38.5809 53.1193C38.3495 53.1109 38.1238 53.0455 37.9238 52.9289C37.7205 52.8114 37.6105 52.6848 37.5938 52.5492C37.577 52.4144 37.6575 52.2955 37.8352 52.1925C38.0241 52.0872 38.2393 52.0385 38.4551 52.0524C38.6871 52.0601 38.9135 52.1251 39.1143 52.2417C39.318 52.3589 39.428 52.4867 39.4432 52.6223C39.4581 52.7582 39.3772 52.8778 39.1993 52.9806C39.0109 53.0856 38.7961 53.1337 38.5809 53.1193ZM39.0592 52.641C39.0109 52.538 38.9269 52.456 38.8229 52.41C38.701 52.3364 38.5646 52.29 38.4231 52.2738C38.3062 52.258 38.1873 52.2797 38.0835 52.3359C37.9893 52.3909 37.9526 52.4559 37.9735 52.531C37.9949 52.6062 38.0743 52.6836 38.2117 52.7631C38.3342 52.8369 38.4709 52.8837 38.6129 52.9007C38.7294 52.9156 38.8476 52.8932 38.9506 52.8368C39.0457 52.7822 39.0816 52.7165 39.0592 52.641Z",
    fill: "#A5AACE"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M71.478 44.1841C71.478 44.6109 71.7801 44.7852 72.1496 44.5719L90.6744 33.8767C90.8697 33.7489 91.0322 33.577 91.1489 33.3749C91.2655 33.1728 91.3331 32.9461 91.3462 32.7131V17.2006C91.3462 16.7739 91.0439 16.5994 90.6744 16.8127L72.1496 27.5081C71.9544 27.6359 71.7919 27.8078 71.6752 28.0099C71.5586 28.212 71.491 28.4386 71.478 28.6716V44.1841Z",
    fill: "#F2F2F7"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7014 44.6298L71.7008 44.6304L71.6929 44.6257L71.7014 44.6298Z",
    fill: "#D0D4F6"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5899 27.185L90.1148 16.4897C90.1821 16.4411 90.2611 16.4111 90.3438 16.4027C90.4265 16.3943 90.5099 16.4078 90.5856 16.4419L90.5859 16.4418L90.587 16.4426L90.5912 16.4449L91.1455 16.765L91.1453 16.7651C91.0695 16.731 90.9861 16.7175 90.9035 16.7259C90.8208 16.7342 90.7418 16.7642 90.6745 16.8128L72.1496 27.5082C71.9544 27.636 71.7919 27.8079 71.6752 28.01C71.5586 28.2121 71.4911 28.4387 71.478 28.6717V44.1843C71.4705 44.2645 71.4832 44.3453 71.515 44.4193C71.5468 44.4933 71.5967 44.5582 71.6601 44.6078L71.1412 44.308L71.1417 44.3073C71.0649 44.2629 71.0029 44.1969 70.9632 44.1176C70.9235 44.0384 70.9078 43.9492 70.9181 43.8611V28.3485C70.9312 28.1155 70.9988 27.8888 71.1155 27.6868C71.2322 27.4847 71.3947 27.3128 71.5899 27.185Z",
    fill: "url(#paint59_linear_835_138800)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8896 22.6345L89.92 20.3077V19.567L85.8896 21.894V22.6345Z",
    fill: "#7F7FF4"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2432 40.8109L78.0699 37.447V37.0765L72.2432 40.4407V40.8109Z",
    fill: "#4141AA"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2432 41.7578L75.2352 40.0304V39.6599L72.2432 41.3873V41.7578Z",
    fill: "#4141AA"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6294 39.8026L76.4051 39.3548V38.9846L75.6294 39.4324V39.8026Z",
    fill: "#4141AA"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2432 32.6169L85.9261 24.7172V24.3469L72.2432 32.2466V32.6169ZM86.851 23.8129V24.1832L88.5827 23.1834V22.8131L86.851 23.8129Z",
    fill: "#4141AA"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5269 34.488L81.4118 29.6292L83.2968 32.3111L79.5269 34.488Z",
    fill: "#D0D4F6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_835_138800",
    x1: 22.4587,
    y1: 23.2538,
    x2: 7.00005,
    y2: 23.2538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1B178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8771"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_835_138800",
    x1: 7,
    y1: 32.707,
    x2: 21.0674,
    y2: 32.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D25C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6952D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_835_138800",
    x1: 31.3501,
    y1: 22.1066,
    x2: 14.4222,
    y2: 51.4265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#7F7FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#5454C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4141AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_835_138800",
    x1: 37.3877,
    y1: 62.9505,
    x2: 67.4869,
    y2: 62.9505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#E6E9F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#F8F9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_835_138800",
    x1: 23.0938,
    y1: 71.2034,
    x2: 42.2386,
    y2: 71.2034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614,
    stopColor: "#EDEFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_835_138800",
    x1: 80.2705,
    y1: 54.6982,
    x2: 99.4156,
    y2: 54.6982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614,
    stopColor: "#EDEFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_835_138800",
    x1: 65.9771,
    y1: 46.4453,
    x2: 118.49,
    y2: 46.4453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#E6E9F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#F8F9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_835_138800",
    x1: 51.6831,
    y1: 54.6978,
    x2: 87.9232,
    y2: 54.6978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_835_138800",
    x1: 46.7919,
    y1: 79.3509,
    x2: 87.8402,
    y2: 79.3509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#D3D8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#D5DAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    stopColor: "#DCE0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#E8EBF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#F9FAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_835_138800",
    x1: 25.766,
    y1: 79.6821,
    x2: 86.9288,
    y2: 79.6821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#D0D4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#BDC1E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_835_138800",
    x1: 41.0004,
    y1: 62.7137,
    x2: 76.1212,
    y2: 62.7137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#E5E9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_835_138800",
    x1: 26.708,
    y1: 73.9465,
    x2: 42.2393,
    y2: 73.9465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.337,
    stopColor: "#E3E7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    stopColor: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_835_138800",
    x1: 25.0469,
    y1: 51.6345,
    x2: 49.7323,
    y2: 51.6345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.982,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_835_138800",
    x1: 10.7524,
    y1: 65.304,
    x2: 30.8569,
    y2: 65.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_835_138800",
    x1: 67.9292,
    y1: 49.6862,
    x2: 87.8921,
    y2: 49.6862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_835_138800",
    x1: 60.1606,
    y1: 73.9655,
    x2: 65.456,
    y2: 83.1375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.319,
    stopColor: "#DDE1F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#F8F8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_835_138800",
    x1: 62.756,
    y1: 74.763,
    x2: 59.3842,
    y2: 68.9231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDC1E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_835_138800",
    x1: 65.796,
    y1: 74.1762,
    x2: 61.4129,
    y2: 66.5844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5555C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_835_138800",
    x1: 63.5051,
    y1: 72.8019,
    x2: 52.84,
    y2: 72.8019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411,
    stopColor: "#A5AACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#AAAED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676,
    stopColor: "#BDC1E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_835_138800",
    x1: 60.6348,
    y1: 75.5366,
    x2: 55.5468,
    y2: 66.7238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9AFD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#AEB4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#D1D4E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124,
    stopColor: "#EAECF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#FAFAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.217,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_835_138800",
    x1: 54.3212,
    y1: 79.6403,
    x2: 50.9496,
    y2: 73.8005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDC1E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_835_138800",
    x1: 57.3602,
    y1: 79.0535,
    x2: 52.977,
    y2: 71.4617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5555C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_835_138800",
    x1: 57.0306,
    y1: 56.1397,
    x2: 63.8792,
    y2: 56.1397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5555C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    stopColor: "#4847B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#252377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_835_138800",
    x1: 64.605,
    y1: 65.6039,
    x2: 51.7358,
    y2: 65.6039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    stopColor: "#BDC1E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682,
    stopColor: "#D0D4F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_835_138800",
    x1: 53.8893,
    y1: 60.0544,
    x2: 64.6049,
    y2: 60.0544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#DBDFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748,
    stopColor: "#F0F2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_835_138800",
    x1: 58.9415,
    y1: 54.9807,
    x2: 55.3076,
    y2: 61.2745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#E1E3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784,
    stopColor: "#D0D4F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_835_138800",
    x1: 53.6519,
    y1: 64.3313,
    x2: 55.5911,
    y2: 66.4059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#EEF0FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_835_138800",
    x1: 47.7904,
    y1: 59.394,
    x2: 53.3715,
    y2: 65.7933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5555C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    stopColor: "#4847B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#252377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_835_138800",
    x1: 112.961,
    y1: 59.9187,
    x2: 119.033,
    y2: 49.4016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.319,
    stopColor: "#DDE1F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#F8F8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_835_138800",
    x1: -104.539,
    y1: 54.2405,
    x2: -101.252,
    y2: 48.5467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D4F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_835_138800",
    x1: -107.504,
    y1: 53.6683,
    x2: -103.23,
    y2: 46.2664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34318F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5555C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_835_138800",
    x1: 103.284,
    y1: 43.504,
    x2: 101.348,
    y2: 42.0719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#252377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    stopColor: "#4847B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5555C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_835_138800",
    x1: 104.369,
    y1: 52.3283,
    x2: 114.767,
    y2: 52.3283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411,
    stopColor: "#D0D4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#BCC1E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676,
    stopColor: "#A9AFD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_835_138800",
    x1: 105.195,
    y1: 54.9945,
    x2: 100.234,
    y2: 46.4021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9AFD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#AEB4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#D1D4E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124,
    stopColor: "#EAECF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#FAFAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.217,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_835_138800",
    x1: -96.3154,
    y1: 58.9956,
    x2: -93.0281,
    y2: 53.3018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D4F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_835_138800",
    x1: -99.2799,
    y1: 58.4235,
    x2: -95.0066,
    y2: 51.0218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34318F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5555C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_835_138800",
    x1: -106.344,
    y1: 45.3105,
    x2: -93.7974,
    y2: 45.3105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    stopColor: "#D0D4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682,
    stopColor: "#BDC1E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_835_138800",
    x1: 100.147,
    y1: 48.5028,
    x2: 107.989,
    y2: 48.5028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#C6CAED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDC1E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_835_138800",
    x1: 113.626,
    y1: 43.8619,
    x2: 115.806,
    y2: 45.5689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#EEF0FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_835_138800",
    x1: 105.852,
    y1: 40.4703,
    x2: 115.844,
    y2: 40.4703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#EEF0FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_835_138800",
    x1: 115.038,
    y1: 44.0903,
    x2: 109.034,
    y2: 50.9809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5555C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    stopColor: "#4847B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#252377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_835_138800",
    x1: 105.486,
    y1: 36.6457,
    x2: 108.874,
    y2: 42.5151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#BDC1E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#C6C9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395,
    stopColor: "#DDDFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#F7F7FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_835_138800",
    x1: 110.055,
    y1: 41.8393,
    x2: 105.584,
    y2: 36.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2A287E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#4847B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5555C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_835_138800",
    x1: 105.756,
    y1: 38.0192,
    x2: 109.815,
    y2: 38.0192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431,
    stopColor: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#F7F7FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_835_138800",
    x1: 108.004,
    y1: 34.6678,
    x2: 111.846,
    y2: 41.3223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#DDDFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729,
    stopColor: "#C6C9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#BDC1E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_835_138800",
    x1: 107.915,
    y1: 74.8182,
    x2: 116.988,
    y2: 74.8182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#D3D8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#D7DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    stopColor: "#F4F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_835_138800",
    x1: 106.217,
    y1: 74.6775,
    x2: 114.059,
    y2: 74.6775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#C6CAED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDC1E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_835_138800",
    x1: 106.961,
    y1: 71.6186,
    x2: 114.054,
    y2: 71.6186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#D3D8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#DBDFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#F1F3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_835_138800",
    x1: 105.262,
    y1: 70.8184,
    x2: 113.104,
    y2: 70.8184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2BD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E9B13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#D89833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D18F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_835_138800",
    x1: 85.8975,
    y1: 81.7201,
    x2: 94.9708,
    y2: 81.7201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#D3D8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#D7DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    stopColor: "#F4F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_835_138800",
    x1: 84.1992,
    y1: 81.5792,
    x2: 92.0408,
    y2: 81.5792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#C6CAED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDC1E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_835_138800",
    x1: 40.0146,
    y1: 82.5646,
    x2: 49.0881,
    y2: 82.5646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#D3D8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#D7DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    stopColor: "#F4F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_835_138800",
    x1: 38.3153,
    y1: 82.4233,
    x2: 46.1569,
    y2: 82.4233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#C6CAED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDC1E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_835_138800",
    x1: 40.3446,
    y1: 79.4994,
    x2: 48.1862,
    y2: 79.4994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6AE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#5A5ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#4848B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4141AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_835_138800",
    x1: 109.081,
    y1: 36.1538,
    x2: 112.104,
    y2: 36.1538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.064,
    stopColor: "#CCCFE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#E8E9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#F9F9FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_835_138800",
    x1: 64.005,
    y1: 16.1373,
    x2: 71.9511,
    y2: 16.1373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#CBCFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#D8DBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#EEF0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_835_138800",
    x1: 62.3213,
    y1: 15.2357,
    x2: 69.9619,
    y2: 15.2357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DADFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#C8CDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC4E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_835_138800",
    x1: 62.3213,
    y1: 16.0367,
    x2: 69.9619,
    y2: 16.0367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F7FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437,
    stopColor: "#5E5ECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.787,
    stopColor: "#4949B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4141AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_835_138800",
    x1: 62.3213,
    y1: 16.8375,
    x2: 69.9619,
    y2: 16.8375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DADFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#C8CDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC4E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_835_138800",
    x1: 85.999,
    y1: 13.7934,
    x2: 69.0711,
    y2: 43.1133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#7F7FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#5454C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4141AA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurpriseMe);
export default __webpack_public_path__ + "static/media/SurpriseMe.95b090ab816040c32ea385a8849f0ea1.svg";
export { ForwardRef as ReactComponent };